import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import AlertDialog from './AlertDialog';

const useStyles = makeStyles(theme => ({
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  }
}));

function DataBase({ database }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(false);

  const openAlertDialog = (data) => {
    setData(data);
    setOpen(true);
  };

  const closeAlertDialog = () => {
    setOpen(false);
  };

  return (
    <Container className={classes.cardGrid} maxWidth="md">
      <CssBaseline />
      <Grid container spacing={4}>
        {
          database.map(data => (
            <Grid item key={data.id} xs={12} sm={6} md={4}>
              <Card className={classes.card}>
                <CardMedia className={classes.cardMedia} image={data.image} title={data.title} />
                <CardContent className={classes.cardContent}>
                  <Typography gutterBottom variant="h5" component="h2" color="secondary">{data.title}</Typography>
                  <Typography>{data.text} <Typography color="secondary" component="span">{data.highlight}</Typography></Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" color="secondary" onClick={() => openAlertDialog(data)}>Ver mais</Button>
                </CardActions>
              </Card>
            </Grid>
          ))
        }
      </Grid>
      { data && <AlertDialog open={open} close={closeAlertDialog} data={data}/>}
    </Container>
  );
};

export default DataBase;